module.exports = __webpack_public_path__ + "img/explode2.8df14f28.svg";